import { useState, useEffect } from "react";
import { ProfileData } from "../types/profile";

interface UserProfileFormData {
  name: string;
  date_of_birth: string;
  email_id: string;
  address_line_1: string;
  phone_number: string;
}

export const useUserProfileForm = (profileData: ProfileData | null) => {
  const [formData, setFormData] = useState<UserProfileFormData>({
    name: "",
    date_of_birth: "",
    email_id: "",
    address_line_1: "",
    phone_number: "",
  });

  useEffect(() => {
    if (profileData) {
      setFormData({
        name: profileData.name || "",
        date_of_birth: profileData.date_of_birth || "",
        email_id: profileData.email_id || "",
        address_line_1: profileData.address_line_1 || "",
        phone_number: profileData.phone_number || "",
      });
    }
  }, [profileData]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return { formData, handleChange };
};